"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TestReactModal = /** @class */ (function (_super) {
    tslib_1.__extends(TestReactModal, _super);
    function TestReactModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestReactModal.setAppElement = function () {
        // it is necessary for the mock to respond to this function
    };
    TestReactModal.prototype.render = function () {
        return (React.createElement("div", { id: this.props.id }, this.props.isOpen && this.props.children));
    };
    return TestReactModal;
}(React.Component));
exports.default = TestReactModal;
//# sourceMappingURL=test_react_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/test_react_modal.js
// module id = 2Id0
// module chunks = 20 21 22